import store from '../store/index';

class UtilService {
  currentUser() {
    return store.state.auth.user;
  }

  currentUserId() {
    return this.currentUser().id;
  }

  currentUseraccessToken() {
    return this.currentUser().accessToken;
  }

  matchUserId(userId) {
    return this.currentUser().id === userId;
  }

  isAdmin() {
    if (this.currentUser() && this.currentUser().roles) {
      return this.currentUser().roles.includes('ROLE_ADMIN');
    }

    return false;
  }

  getActiveConversation() {
    return store.state.application.activeConversation;
  }

  getMessagesForConversation() {
    return this.getActiveConversation().id === null
      ? []
      : store.state.message.appMessages
          .filter(
            (message) => message.appId === this.getActiveConversation().id
          )
          .sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt));
  }

  getStudentDocsFromApplication() {
    return this.getActiveConversation().id === null
      ? []
      : store.state.application.applications.filter(
          (app) => app.id === this.getActiveConversation().id
        )[0].studentDocuments;
  }

  getUnresolvedCommentsFromApplication() {
    return this.getActiveConversation().id === null
      ? false
      : store.state.application.applications.filter(
          (app) => app.id === this.getActiveConversation().id
        )[0].unresolvedComments;
  }

  getActiveApplication() {
    return this.getActiveConversation().id === null
      ? null
      : store.state.application.applications.filter(
          (app) => app.id === this.getActiveConversation().id
        )[0];
  }

  getAppIdForLoadedMessages() {
    return store.state.application.applications.map((app) => app.id);
  }

  getStudentIdsForApps() {
    return store.state.application.applications.map((app) => app.studentId);
  }

  getTeamLeaders() {
    return store.state.users.users.filter((user) => user.isTeamLeader);
  }

  mappedUsernames() {
    return store.state.users.users.map((user) => user.username);
  }

  getUserIdByUsername(username) {
    const foundUser = store.state.users.users.filter(
      (user) => user.username === username
    );
    return foundUser && foundUser.length ? foundUser[0].id : null;
  }

  multiSelectMappedUsernames() {
    return store.state.users.users.map((user) => {
      return {
        value: user.username,
        id: user.id,
      };
    });
  }

  userTeamId() {
    return this.mappedUsers().filter(
      (user) => user.id === this.currentUser.id
    )[0].teamId;
  }

  mappedUsers() {
    return store.state.users.users.map((teamLeader) => {
      return {
        id: teamLeader.id,
        isTeamLeader: teamLeader.isTeamLeader,
        username: teamLeader.username,
        teamId: teamLeader.team_users.length
          ? teamLeader.team_users[0].teamId
          : null,
        teamName: teamLeader.team_users.length
          ? teamLeader.team_users[0].team.name
          : null,
      };
    });
  }

  isModerator() {
    if (this.currentUser() && this.currentUser().roles) {
      return this.currentUser().roles.includes('ROLE_MODERATOR');
    }

    return false;
  }

  isManager() {
    return store.state.users.isManager;
  }

  isManagement() {
    return this.isModerator() || this.isAdmin();
  }

  isTeamLeader() {
    return this.currentUser().isTeamLeader;
  }

  currentUserTeam() {
    const filteredUsers = store.state.users.users.filter(
      (user) => this.currentUser().id === user.id
    );
    return filteredUsers && filteredUsers.length
      ? filteredUsers[0].team_users
      : [];
  }

  arrayToCsv(data) {
    const array = [Object.keys(data[0])].concat(data);

    return array
      .map((it) => {
        return Object.values(it).toString();
      })
      .join('\n');
  }

  /* https://stackoverflow.com/a/68146412 */
  /* downloadBlob(csv, 'export.csv', 'text/csv;charset=utf-8;')*/
  downloadBlob(content, filename, contentType) {
    // Create a blob
    var blob = new Blob([content], {
      type: contentType,
    });
    var url = URL.createObjectURL(blob);

    // Create a link to download it
    var pom = document.createElement('a');
    pom.href = url;
    pom.setAttribute('download', filename);
    pom.click();
  }

  getFileExtenstion(filename) {
    return filename.split('.').pop();
  }

  deepCopy(data) {
    return data ? JSON.parse(JSON.stringify(data)) : data;
  }

  studentName(student) {
    try {
      return (
        student.title + ' ' + student.first_name + ' ' + student.last_name + ' '
      );
    } catch (error) {
      return null;
    }
  }

  isValidDate(d) {
    return d instanceof Date && !isNaN(d);
  }

  formatDateWithTime(dateString) {
    if (!dateString) return null;

    return new Intl.DateTimeFormat('en-GB', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    }).format(new Date(dateString));
  }

  getUserTeam(user) {
    let teamId = null;
    let teamName = null;

    if (user.length) {
      const userTeam = user.filter((user) => !user.isManager)[0];
      if (userTeam) {
        teamId = userTeam.team.id;
        teamName = userTeam.team.name;
      }
    }

    return {
      teamId,
      teamName,
    };
  }

  generateFilterArray(data) {
    return [...new Set(data)]
      .filter((x) => x)
      .map((status) => {
        return {
          value: status,
        };
      });
  }

  getUniqueUsersWithUniIDs(data) {
    // Create a map to store the unique users with their uniIds
    const userMap = new Map();

    // Iterate over each item in the data array
    data.forEach((item) => {
      const { username, id, uniId } = item;

      // If the user already exists in the map, add the uniId to their uniIds array
      if (userMap.has(id)) {
        userMap.get(id).uniIds.push(uniId);
      } else {
        // If the user doesn't exist, create a new entry in the map
        userMap.set(id, { username, id, uniIds: [uniId] });
      }
    });

    return Array.from(userMap.values());
  }

  getUserModerators() {
    return store.state.users.users.filter((user) => user.userRole >= 2);
  }

  getUsername(id) {
    const filteredUserById = store.state.users.users.filter(
      (user) => user.id === parseInt(id)
    );
    return filteredUserById && filteredUserById.length
      ? filteredUserById[0].username
      : 'User not found';
  }

  getIdByUsername(username) {
    const filteredUserById = store.state.users.users.filter(
      (user) => user.username === username
    );
    return filteredUserById && filteredUserById.length
      ? filteredUserById[0].id
      : null;
  }

  currentYear() {
    return new Date().getFullYear();
  }

  getUniversities() {
    return Object.keys(store.state.application_filter.filterOptions).length
      ? store.state.application_filter.filterOptions.universities
      : [];
  }

  dateCheck(from, to, check) {
    return (
      Date.parse(check) <= Date.parse(to) &&
      Date.parse(check) >= Date.parse(from)
    );
  }

  getTeamLeadersApplications() {
    return store.state.users.teamLeaders;
  }

  formatDate(dateString) {
    return new Intl.DateTimeFormat('en-GB', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(new Date(dateString));
  }

  getNotificationStatus(app) {
    switch (true) {
      case (app.status === 'Unconditional' ||
        app.status === 'Awaiting Uncon' ||
        app.status === 'Pending') &&
        !app.startedStudentForm &&
        !app.studentFormStatus:
        return 'notStartedSfe';

      case app.studentFormStatus === 'Draft':
        return 'inDraft';

      case app.studentFormStatus === 'Info Required':
        return 'infoRequired';

      case app.studentFormStatus === 'Approved' && !app.uploadedPrintScreen:
        return 'noPrintScreen';

      default:
        return null;
    }
  }

  visualUsername(username) {
    var i,
      frags = username.split('.');
    for (i = 0; i < frags.length; i++) {
      frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
    }
    return frags.join(' ');
  }

  clearFilters() {
    localStorage.removeItem('applicationFilters');
    return null;
  }
}

export default new UtilService();
